import Tooltip from "@mui/material/Tooltip";

import { Edit, MoreVert, Preview } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useState, useEffect, useRef } from "react";
import Typography from "@mui/material/Typography";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import ScheduleIcon from "@mui/icons-material/Schedule";
import CancelScheduleSendIcon from "@mui/icons-material/CancelScheduleSend";
import ScheduleSendIcon from "@mui/icons-material/ScheduleSend";
import StartIcon from "@mui/icons-material/Start";

const MoreAction = ({
  params,
  triggerButtonHandler,
  scheduleButtonHandler,
  stopButtonHandler,
}) => {
  let options = [];
  const ITEM_HEIGHT = 48;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleMenuClick = (event) => {
    setAnchorEl(event && event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  switch (params.scheduleButtonDisable) {
    case true:
      options = ["Trigger", "Stop"];
      break;
    case false:
      options = ["Trigger", "Schedule", "Stop"];
      break;
    default:
      break;
  }

  const handleIconClick = (value, params) => {
    handleClose();
    switch (value) {
      case "Trigger":
        triggerButtonHandler(params);
        break;
      case "Schedule":
        scheduleButtonHandler(params);
        break;
      case "Stop":
        stopButtonHandler(params);
        break;
    }
  };
  return (
    <>
      <Tooltip title="More Actions">
        <IconButton
          aria-label="more"
          id="long-button"
          aria-controls={open ? "long-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          onClick={handleMenuClick}
          disabled={!params.triggerStatus}
        >
          <MoreVert />
        </IconButton>
      </Tooltip>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: "100px",
          },
        }}
      >
        {options.map((option, index) => (
          <MenuItem
            key={option}
            onClick={() => handleIconClick(option, params)}
          >
            <IconButton
              size="small"
              sx={{
                color: "#004A92",
                display: "flex",
                gap: "5px",
                padding: 0,
              }}
            >
              {(() => {
                switch (option) {
                  case "Trigger":
                    return (
                      <>
                        <StartIcon fontSize="small" />
                        <Typography
                          variant="inherit"
                          component="div"
                          fontSize="14px"
                          fontWeight="inherit"
                          sx={{ color: "#004A92", fontWeight: "520" }}
                        >
                          {option}
                        </Typography>
                      </>
                    );

                  case "Schedule":
                    return (
                      <>
                        <ScheduleIcon fontSize="small" color="inherit" />
                        <Typography
                          variant="inherit"
                          component="div"
                          fontSize="14px"
                          fontWeight="inherit"
                          sx={{ color: "#004A92", fontWeight: "520" }}
                        >
                          {option}
                        </Typography>
                      </>
                    );
                  case "Stop":
                    return (
                      <>
                        <CancelScheduleSendIcon fontSize="small" />
                        <Typography
                          variant="inherit"
                          component="div"
                          fontSize="14px"
                          fontWeight="inherit"
                          sx={{ color: "#004A92", fontWeight: "520" }}
                        >
                          {option}
                        </Typography>
                      </>
                    );
                  default:
                    return;
                }
              })()}
            </IconButton>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default MoreAction;
